(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/mybets-common-wager/assets/javascripts/models/subscription.js') >= 0) return;  svs.modules.push('/components/numbergames/mybets-common-wager/assets/javascripts/models/subscription.js');

'use strict';

svs.numbergames.mybets_common_wager.models.Subscription = svs.numbergames.core.NumbergamesModel.extend({
  idAttribute: 'subscriptionId',
  defaults: {
    isSubscriptionModel: true,
    subscriptionId: undefined,
    channel: undefined,
    isSubscription: undefined,
    productId: undefined,
    productName: undefined,
    isEditableSubscription: undefined,
    paymentType: undefined,
    currIntvFrom: undefined,
    currIntvTo: undefined,
    prevPayDate: undefined,
    prevPayAmount: undefined,
    createdDate: undefined,
    nextDraw: undefined,
    description: undefined,
    extraDescription: undefined,
    rowCount: undefined,
    hasJoker: undefined,
    isSingleWager: undefined,
    isSystemWager: undefined,
    isPackageWager: undefined,
    weeklyAmount: undefined,
    addonAmount: undefined,
    bet: undefined,
    jokerBet: undefined,
    drawsPerWeek: undefined,
    hasLotto2: undefined,
    weekDays: undefined,
    gameDays: undefined
  },
  parse(attrs, options) {
    attrs = svs.numbergames.mybets_core_wager.parsers.subscription.parseSubscription(attrs);
    if (attrs.bet) {
      attrs.bet = new svs.numbergames.mybets_common_wager.models.Bet(attrs.bet, options);
    }
    if (attrs.jokerBet) {
      attrs.jokerBet = new svs.numbergames.mybets_common_wager.models.Bet(attrs.jokerBet, options);
    }
    return attrs;
  }
});

 })(window);